import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CTAProps {
  onGetStarted: () => void;
}

const CTA = ({ onGetStarted }: CTAProps) => {
  return (
    <section className="py-24 px-4 bg-gradient-to-br from-primary via-primary to-blue-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" 
             style={{
               backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
               backgroundSize: '32px 32px'
             }}
        />
      </div>
      
      {/* Animated Blobs */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-blue-400/20 rounded-full blur-3xl animate-bounce-subtle" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl animate-bounce-subtle" style={{ animationDelay: '1s' }} />

      <div className="max-w-4xl mx-auto text-center relative z-10 animate-fade-in-up">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-8 leading-tight">
          Ready to Speed Up Your Invoicing?
        </h2>
        <p className="text-lg md:text-xl text-blue-100 mb-12 max-w-2xl mx-auto leading-relaxed">
          Join hundreds of Malaysian contractors who are getting paid faster with SnapBill.my
        </p>

        <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
          <Button 
            size="lg"
            onClick={onGetStarted}
            className="group w-full sm:w-auto bg-accent hover:bg-accent/90 text-accent-foreground shadow-2xl hover:shadow-accent/30 text-base md:text-lg px-12 py-8 rounded-2xl font-bold transition-all duration-300 hover:scale-105 hover:-translate-y-1"
          >
            Get Started for Free
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-2 transition-transform duration-300" />
          </Button>
        </div>

        <div className="mt-16 pt-12 border-t border-white/20">
          <div className="grid grid-cols-3 gap-10 max-w-3xl mx-auto">
            <div className="text-center group cursor-default">
              <div className="text-4xl md:text-5xl font-bold text-white mb-3 group-hover:scale-110 transition-transform duration-300">5</div>
              <div className="text-sm md:text-base text-blue-100 font-medium">Free Tries</div>
            </div>
            <div className="text-center group cursor-default">
              <div className="text-4xl md:text-5xl font-bold text-white mb-3 group-hover:scale-110 transition-transform duration-300">&lt;60s</div>
              <div className="text-sm md:text-base text-blue-100 font-medium">Setup Time</div>
            </div>
            <div className="text-center group cursor-default">
              <div className="text-4xl md:text-5xl font-bold text-white mb-3 group-hover:scale-110 transition-transform duration-300">∞</div>
              <div className="text-sm md:text-base text-blue-100 font-medium">After Sign Up</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
